if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = [];
        this.panels = [];
        this.indicator = null;
      }

      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.indicator = this.querySelector('.product-tabs__indicator');

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectTab(tab));
          tab.addEventListener('keydown', (e) => this.handleKeydown(e));
        });

        this.updateIndicator();

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (!this.contains(e.target)) return;
            const index = this.panels.indexOf(e.target);
            if (index >= 0 && this.tabs[index]) {
              this.selectTab(this.tabs[index]);
            }
          });
        }
      }

      selectTab(selectedTab) {
        this.tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.setAttribute('aria-selected', isSelected);
          tab.setAttribute('tabindex', isSelected ? '0' : '-1');
        });

        const selectedId = selectedTab.getAttribute('aria-controls');
        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== selectedId;
        });

        this.updateIndicator();
      }

      updateIndicator() {
        if (!this.indicator) return;
        const activeTab = this.querySelector('[role="tab"][aria-selected="true"]');
        if (!activeTab) return;

        const tablist = activeTab.parentElement;
        const left = activeTab.offsetLeft - tablist.scrollLeft;
        const width = activeTab.offsetWidth;

        this.style.setProperty('--tab-indicator-left', `${left}px`);
        this.style.setProperty('--tab-indicator-width', `${width}px`);
      }

      handleKeydown(e) {
        const currentIndex = this.tabs.indexOf(e.currentTarget);
        let newIndex;

        switch (e.key) {
          case 'ArrowRight':
            newIndex = (currentIndex + 1) % this.tabs.length;
            break;
          case 'ArrowLeft':
            newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
            break;
          case 'Home':
            newIndex = 0;
            break;
          case 'End':
            newIndex = this.tabs.length - 1;
            break;
          default:
            return;
        }

        e.preventDefault();
        this.tabs[newIndex].focus();
        this.selectTab(this.tabs[newIndex]);
      }
    }
  );
}
